/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CallStatusResponse } from '../models';
// @ts-ignore
import type { CallTerminationResponse } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { OutboundCallRequest } from '../models';
// @ts-ignore
import type { OutboundCallResponse } from '../models';
/**
 * OutboundCallsApi - axios parameter creator
 * @export
 */
export const OutboundCallsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the current status of an outbound call.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallStatusResponse with current call status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If status retrieval fails
         * @summary Get Call Status
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallStatusApiV1OutboundCallsRoomNameStatusGet: async (roomName: string, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomName' is not null or undefined
            assertParamExists('getCallStatusApiV1OutboundCallsRoomNameStatusGet', 'roomName', roomName)
            const localVarPath = `/api/v1/outbound-calls/{room_name}/status`
                .replace(`{${"room_name"}}`, encodeURIComponent(String(roomName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current status of an outbound call.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallStatusResponse with current call status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If status retrieval fails
         * @summary Get Call Status
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallStatusApiV1OutboundCallsRoomNameStatusGet_1: async (roomName: string, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomName' is not null or undefined
            assertParamExists('getCallStatusApiV1OutboundCallsRoomNameStatusGet_1', 'roomName', roomName)
            const localVarPath = `/api/v1/outbound-calls/{room_name}/status`
                .replace(`{${"room_name"}}`, encodeURIComponent(String(roomName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Health check endpoint for outbound calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1OutboundCallsHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/outbound-calls/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Health check endpoint for outbound calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1OutboundCallsHealthGet_2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/outbound-calls/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate an outbound call to a phone number.  This endpoint creates a LiveKit room and initiates a SIP call to the specified phone number. The outbound agent will join the room and handle the conversation.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     request: Outbound call request containing phone number  Returns:     OutboundCallResponse with call details  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the agent is not found     BadRequestError: If the agent is misconfigured     InternalError: If call initiation fails
         * @summary Initiate Outbound Call
         * @param {string} agentId 
         * @param {OutboundCallRequest} outboundCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost: async (agentId: string, outboundCallRequest: OutboundCallRequest, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost', 'agentId', agentId)
            // verify required parameter 'outboundCallRequest' is not null or undefined
            assertParamExists('initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost', 'outboundCallRequest', outboundCallRequest)
            const localVarPath = `/api/v1/outbound-calls/initiate/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outboundCallRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate an outbound call to a phone number.  This endpoint creates a LiveKit room and initiates a SIP call to the specified phone number. The outbound agent will join the room and handle the conversation.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     request: Outbound call request containing phone number  Returns:     OutboundCallResponse with call details  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the agent is not found     BadRequestError: If the agent is misconfigured     InternalError: If call initiation fails
         * @summary Initiate Outbound Call
         * @param {string} agentId 
         * @param {OutboundCallRequest} outboundCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost_3: async (agentId: string, outboundCallRequest: OutboundCallRequest, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost_3', 'agentId', agentId)
            // verify required parameter 'outboundCallRequest' is not null or undefined
            assertParamExists('initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost_3', 'outboundCallRequest', outboundCallRequest)
            const localVarPath = `/api/v1/outbound-calls/initiate/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outboundCallRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Terminate an outbound call.  This endpoint terminates an active outbound call by deleting the LiveKit room.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallTerminationResponse with termination status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If call termination fails
         * @summary Terminate Call
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCallApiV1OutboundCallsRoomNameTerminateDelete: async (roomName: string, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomName' is not null or undefined
            assertParamExists('terminateCallApiV1OutboundCallsRoomNameTerminateDelete', 'roomName', roomName)
            const localVarPath = `/api/v1/outbound-calls/{room_name}/terminate`
                .replace(`{${"room_name"}}`, encodeURIComponent(String(roomName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Terminate an outbound call.  This endpoint terminates an active outbound call by deleting the LiveKit room.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallTerminationResponse with termination status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If call termination fails
         * @summary Terminate Call
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCallApiV1OutboundCallsRoomNameTerminateDelete_4: async (roomName: string, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomName' is not null or undefined
            assertParamExists('terminateCallApiV1OutboundCallsRoomNameTerminateDelete_4', 'roomName', roomName)
            const localVarPath = `/api/v1/outbound-calls/{room_name}/terminate`
                .replace(`{${"room_name"}}`, encodeURIComponent(String(roomName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OutboundCallsApi - functional programming interface
 * @export
 */
export const OutboundCallsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OutboundCallsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the current status of an outbound call.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallStatusResponse with current call status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If status retrieval fails
         * @summary Get Call Status
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallStatusApiV1OutboundCallsRoomNameStatusGet(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallStatusApiV1OutboundCallsRoomNameStatusGet(roomName, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutboundCallsApi.getCallStatusApiV1OutboundCallsRoomNameStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current status of an outbound call.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallStatusResponse with current call status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If status retrieval fails
         * @summary Get Call Status
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallStatusApiV1OutboundCallsRoomNameStatusGet_1(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallStatusApiV1OutboundCallsRoomNameStatusGet_1(roomName, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutboundCallsApi.getCallStatusApiV1OutboundCallsRoomNameStatusGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Health check endpoint for outbound calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckApiV1OutboundCallsHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckApiV1OutboundCallsHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutboundCallsApi.healthCheckApiV1OutboundCallsHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Health check endpoint for outbound calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckApiV1OutboundCallsHealthGet_2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckApiV1OutboundCallsHealthGet_2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutboundCallsApi.healthCheckApiV1OutboundCallsHealthGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate an outbound call to a phone number.  This endpoint creates a LiveKit room and initiates a SIP call to the specified phone number. The outbound agent will join the room and handle the conversation.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     request: Outbound call request containing phone number  Returns:     OutboundCallResponse with call details  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the agent is not found     BadRequestError: If the agent is misconfigured     InternalError: If call initiation fails
         * @summary Initiate Outbound Call
         * @param {string} agentId 
         * @param {OutboundCallRequest} outboundCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost(agentId: string, outboundCallRequest: OutboundCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutboundCallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost(agentId, outboundCallRequest, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutboundCallsApi.initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate an outbound call to a phone number.  This endpoint creates a LiveKit room and initiates a SIP call to the specified phone number. The outbound agent will join the room and handle the conversation.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     request: Outbound call request containing phone number  Returns:     OutboundCallResponse with call details  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the agent is not found     BadRequestError: If the agent is misconfigured     InternalError: If call initiation fails
         * @summary Initiate Outbound Call
         * @param {string} agentId 
         * @param {OutboundCallRequest} outboundCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost_3(agentId: string, outboundCallRequest: OutboundCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutboundCallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost_3(agentId, outboundCallRequest, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutboundCallsApi.initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Terminate an outbound call.  This endpoint terminates an active outbound call by deleting the LiveKit room.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallTerminationResponse with termination status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If call termination fails
         * @summary Terminate Call
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminateCallApiV1OutboundCallsRoomNameTerminateDelete(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallTerminationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminateCallApiV1OutboundCallsRoomNameTerminateDelete(roomName, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutboundCallsApi.terminateCallApiV1OutboundCallsRoomNameTerminateDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Terminate an outbound call.  This endpoint terminates an active outbound call by deleting the LiveKit room.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallTerminationResponse with termination status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If call termination fails
         * @summary Terminate Call
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminateCallApiV1OutboundCallsRoomNameTerminateDelete_4(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallTerminationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminateCallApiV1OutboundCallsRoomNameTerminateDelete_4(roomName, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutboundCallsApi.terminateCallApiV1OutboundCallsRoomNameTerminateDelete_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OutboundCallsApi - factory interface
 * @export
 */
export const OutboundCallsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OutboundCallsApiFp(configuration)
    return {
        /**
         * Get the current status of an outbound call.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallStatusResponse with current call status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If status retrieval fails
         * @summary Get Call Status
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallStatusApiV1OutboundCallsRoomNameStatusGet(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<CallStatusResponse> {
            return localVarFp.getCallStatusApiV1OutboundCallsRoomNameStatusGet(roomName, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current status of an outbound call.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallStatusResponse with current call status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If status retrieval fails
         * @summary Get Call Status
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallStatusApiV1OutboundCallsRoomNameStatusGet_1(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<CallStatusResponse> {
            return localVarFp.getCallStatusApiV1OutboundCallsRoomNameStatusGet_1(roomName, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Health check endpoint for outbound calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1OutboundCallsHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckApiV1OutboundCallsHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Health check endpoint for outbound calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1OutboundCallsHealthGet_2(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckApiV1OutboundCallsHealthGet_2(options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate an outbound call to a phone number.  This endpoint creates a LiveKit room and initiates a SIP call to the specified phone number. The outbound agent will join the room and handle the conversation.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     request: Outbound call request containing phone number  Returns:     OutboundCallResponse with call details  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the agent is not found     BadRequestError: If the agent is misconfigured     InternalError: If call initiation fails
         * @summary Initiate Outbound Call
         * @param {string} agentId 
         * @param {OutboundCallRequest} outboundCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost(agentId: string, outboundCallRequest: OutboundCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<OutboundCallResponse> {
            return localVarFp.initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost(agentId, outboundCallRequest, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate an outbound call to a phone number.  This endpoint creates a LiveKit room and initiates a SIP call to the specified phone number. The outbound agent will join the room and handle the conversation.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     request: Outbound call request containing phone number  Returns:     OutboundCallResponse with call details  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the agent is not found     BadRequestError: If the agent is misconfigured     InternalError: If call initiation fails
         * @summary Initiate Outbound Call
         * @param {string} agentId 
         * @param {OutboundCallRequest} outboundCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost_3(agentId: string, outboundCallRequest: OutboundCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<OutboundCallResponse> {
            return localVarFp.initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost_3(agentId, outboundCallRequest, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Terminate an outbound call.  This endpoint terminates an active outbound call by deleting the LiveKit room.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallTerminationResponse with termination status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If call termination fails
         * @summary Terminate Call
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCallApiV1OutboundCallsRoomNameTerminateDelete(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<CallTerminationResponse> {
            return localVarFp.terminateCallApiV1OutboundCallsRoomNameTerminateDelete(roomName, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Terminate an outbound call.  This endpoint terminates an active outbound call by deleting the LiveKit room.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallTerminationResponse with termination status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If call termination fails
         * @summary Terminate Call
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCallApiV1OutboundCallsRoomNameTerminateDelete_4(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<CallTerminationResponse> {
            return localVarFp.terminateCallApiV1OutboundCallsRoomNameTerminateDelete_4(roomName, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OutboundCallsApi - object-oriented interface
 * @export
 * @class OutboundCallsApi
 * @extends {BaseAPI}
 */
export class OutboundCallsApi extends BaseAPI {
    /**
     * Get the current status of an outbound call.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallStatusResponse with current call status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If status retrieval fails
     * @summary Get Call Status
     * @param {string} roomName 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundCallsApi
     */
    public getCallStatusApiV1OutboundCallsRoomNameStatusGet(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return OutboundCallsApiFp(this.configuration).getCallStatusApiV1OutboundCallsRoomNameStatusGet(roomName, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current status of an outbound call.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallStatusResponse with current call status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If status retrieval fails
     * @summary Get Call Status
     * @param {string} roomName 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundCallsApi
     */
    public getCallStatusApiV1OutboundCallsRoomNameStatusGet_1(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return OutboundCallsApiFp(this.configuration).getCallStatusApiV1OutboundCallsRoomNameStatusGet_1(roomName, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Health check endpoint for outbound calls service.  Returns:     Simple health status
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundCallsApi
     */
    public healthCheckApiV1OutboundCallsHealthGet(options?: RawAxiosRequestConfig) {
        return OutboundCallsApiFp(this.configuration).healthCheckApiV1OutboundCallsHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Health check endpoint for outbound calls service.  Returns:     Simple health status
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundCallsApi
     */
    public healthCheckApiV1OutboundCallsHealthGet_2(options?: RawAxiosRequestConfig) {
        return OutboundCallsApiFp(this.configuration).healthCheckApiV1OutboundCallsHealthGet_2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate an outbound call to a phone number.  This endpoint creates a LiveKit room and initiates a SIP call to the specified phone number. The outbound agent will join the room and handle the conversation.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     request: Outbound call request containing phone number  Returns:     OutboundCallResponse with call details  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the agent is not found     BadRequestError: If the agent is misconfigured     InternalError: If call initiation fails
     * @summary Initiate Outbound Call
     * @param {string} agentId 
     * @param {OutboundCallRequest} outboundCallRequest 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundCallsApi
     */
    public initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost(agentId: string, outboundCallRequest: OutboundCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return OutboundCallsApiFp(this.configuration).initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost(agentId, outboundCallRequest, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate an outbound call to a phone number.  This endpoint creates a LiveKit room and initiates a SIP call to the specified phone number. The outbound agent will join the room and handle the conversation.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     request: Outbound call request containing phone number  Returns:     OutboundCallResponse with call details  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the agent is not found     BadRequestError: If the agent is misconfigured     InternalError: If call initiation fails
     * @summary Initiate Outbound Call
     * @param {string} agentId 
     * @param {OutboundCallRequest} outboundCallRequest 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundCallsApi
     */
    public initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost_3(agentId: string, outboundCallRequest: OutboundCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return OutboundCallsApiFp(this.configuration).initiateOutboundCallApiV1OutboundCallsInitiateAgentIdPost_3(agentId, outboundCallRequest, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Terminate an outbound call.  This endpoint terminates an active outbound call by deleting the LiveKit room.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallTerminationResponse with termination status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If call termination fails
     * @summary Terminate Call
     * @param {string} roomName 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundCallsApi
     */
    public terminateCallApiV1OutboundCallsRoomNameTerminateDelete(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return OutboundCallsApiFp(this.configuration).terminateCallApiV1OutboundCallsRoomNameTerminateDelete(roomName, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Terminate an outbound call.  This endpoint terminates an active outbound call by deleting the LiveKit room.  **Authentication**: Requires JWT token or API key with \'call:initiate\' permission.  Args:     room_name: The LiveKit room name for the call  Returns:     CallTerminationResponse with termination status  Raises:     ForbiddenError: If the user lacks required permission     NotFoundError: If the room belongs to another organization     InternalError: If call termination fails
     * @summary Terminate Call
     * @param {string} roomName 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundCallsApi
     */
    public terminateCallApiV1OutboundCallsRoomNameTerminateDelete_4(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return OutboundCallsApiFp(this.configuration).terminateCallApiV1OutboundCallsRoomNameTerminateDelete_4(roomName, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }
}

